import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './why-you-should-read-every-day.component.html',
  styleUrls: ['./why-you-should-read-every-day.component.scss']
})
export class WhyYouShouldReadEveryDayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
